module.exports = __webpack_public_path__ + "static/A4_Darmstadt-Logo_rgb-3c-34fbd5d613dde1025877435b2a6b1eab.jpg";